import { LanguageTags } from '../constants'

export class LanguageLocale {
  constructor ({ id = -1, languageTag = LanguageTags.EN } = {}) {
    this.id = id
    this.languageTag = languageTag
  }

  toRequestBody = () => {
    return { ...this }
  }
}
